import { Component } from "react"
import PropTypes from "prop-types"
import { chain, capitalize } from "lodash"
import { List, ListSubheader, Button, Badge } from "@mui/material"
import Tooltip from "components/material/tooltip"
import { FACET } from "../../shapes"
import FacetListItem from "../list-item"

export default class FacetList extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    facets: PropTypes.arrayOf(FACET).isRequired,
    selected: PropTypes.arrayOf(FACET).isRequired,
    toggleFacet: PropTypes.func.isRequired,
    expandFacet: PropTypes.func.isRequired,
  }

  onClick = (id) => {
    const { type, toggleFacet } = this.props
    toggleFacet(type, id)
  }

  expand = () => {
    const { type, expandFacet } = this.props
    expandFacet(type)
  }

  render() {
    const { type, facets, selected } = this.props

    if (facets.length <= 1) {
      return null
    }

    return <List subheader={<ListSubheader className="category-header">
      {selected.length > 0
        ? <Badge
            color="secondary"
            badgeContent={<Tooltip title={selected.map((f, i) => <div key={i}>{f.label}</div>)}>
              <span>{selected.length}</span>
            </Tooltip>}
            classes={{ badge: "badge" }}
        >
          {capitalize(type)}
        </Badge> : capitalize(type)}

    </ListSubheader>}
    >
      {chain(facets)
        .take(5)
        .map(facet => <FacetListItem key={facet.id} {...facet} onClick={this.onClick} />)
        .value()}
      {facets.length > 5 && <Button color="primary" onClick={this.expand}>See More</Button>}
    </List>
  }
}
